import { useCallback } from "react";
import {
  trackCampaignSelected as trackCampaignSelectedService,
  trackChangeFilterApplied as trackChangeFilterAppliedService,
  trackChartTooltipViewed as trackChartTooltipViewedService,
  trackDashboardViewed as trackDashboardViewedService,
  trackDateRangeSelected as trackDateRangeSelectedService,
  trackMetricSelected as trackMetricSelectedService,
  trackSherlockImpactMessageDisplayed as trackSherlockImpactMessageDisplayedService,
} from "../services/SherlockTrackingEvents";

export function useSherlockTracking(userId?: string) {
  const trackDashboardViewed = useCallback(() => {
    trackDashboardViewedService({ user_id: userId });
  }, [userId]);

  const trackDateRangeSelected = useCallback(
    (startDate: Date | string, endDate: Date | string) => {
      trackDateRangeSelectedService({
        start_date: startDate,
        end_date: endDate,
        user_id: userId,
      });
    },
    [userId],
  );

  const trackCampaignSelected = useCallback(
    (organization: string, campaignId: string) => {
      trackCampaignSelectedService({
        organization,
        campaign_id: campaignId,
        user_id: userId,
      });
    },
    [userId],
  );

  const trackMetricSelected = useCallback(
    (metricName: string) => {
      trackMetricSelectedService({
        metric_name: metricName,
        user_id: userId,
      });
    },
    [userId],
  );

  const trackChangeFilterApplied = useCallback(
    (filterName: string, filterState: boolean) => {
      trackChangeFilterAppliedService({
        filter_name: filterName,
        filter_state: filterState,
        user_id: userId,
      });
    },
    [userId],
  );

  const trackChartTooltipViewed = useCallback(
    (timestampHovered: Date | string, actualValue?: number | string, predictedValue?: number | string) => {
      trackChartTooltipViewedService({
        timestamp_hovered: timestampHovered,
        actual_value: actualValue,
        predicted_value: predictedValue,
        user_id: userId,
      });
    },
    [userId],
  );

  const trackSherlockImpactMessageDisplayed = useCallback(
    (messageText: string) => {
      trackSherlockImpactMessageDisplayedService({
        message_text: messageText,
        user_id: userId,
      });
    },
    [userId],
  );

  return {
    trackDashboardViewed,
    trackDateRangeSelected,
    trackCampaignSelected,
    trackMetricSelected,
    trackChangeFilterApplied,
    trackChartTooltipViewed,
    trackSherlockImpactMessageDisplayed,
  };
}
